import './img.scss';
import React from 'react';
import { lang } from '@umu/ukit-lang';
import { Editor } from '@tiptap/react';
import { Iconfont } from '@umu/umu-design';
import { EMediaType } from '@umu/umu-types';
import { Tooltip } from '../../tooltip/tooltip';
import { ImageCropUploader, IChooseImageInfo } from 'businessCommon/src/components/imageCrop';
import { E_PLATFORM } from '../../../interface';

export const ImgMenu = (editor: Editor, platform: E_PLATFORM, teacherId = '') => {
    const addImg = (data: IChooseImageInfo[]) => {
        editor.commands.setImage({ src: data[0].url });
    };

    return (
        <Tooltip title={lang('插入图片')} key="add-img">
            <div className="menu__add-img flex--center">
                <ImageCropUploader
                    cropClassName={`rich-text-comp__crop-img-modal rich-text-img-crop_platform-${platform}`}
                    teacherId={teacherId}
                    mediaType={EMediaType.PIC_WEIKE}
                    onConfirm={addImg}
                >
                    <button className="menu-item">
                        <Iconfont type="AddPicture" />
                    </button>
                </ImageCropUploader>
            </div>
        </Tooltip>
    );
};
